import * as LiveSessionVideoAlertTypes from "./liveSessionVideoAlertTypes";

export const LiveSessionVideoAlerts = {
  [LiveSessionVideoAlertTypes.TEACHER_LOW_BITRATE_QUALITY]: {
    message: "live_sessions.connection_error_teacher",
    type: "warning",
  },
  [LiveSessionVideoAlertTypes.TEACHER_STREAMLABS_ERROR]: {
    message: "live_sessions.streamlabs_error_teacher",
    type: "error",
  },
};
